// Formats cents with the store's own money format (e.g. "$ {{amount}} USD"),
// so prices updated by JS look the same as the ones rendered by Liquid.
function mtMoney(cents) {
  var root = document.querySelector('[data-mt-money-format]');
  var format = root ? (root.getAttribute('data-mt-money-format') || '').replace(/<[^>]*>/g, '') : '';
  if (!format || format.indexOf('{{') === -1) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
  }
  function group(n, thousands, decimal, places) {
    var fixed = (n / 100).toFixed(places);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
    switch (name) {
      case 'amount': return group(cents, ',', '.', 2);
      case 'amount_no_decimals': return group(cents, ',', '.', 0);
      case 'amount_with_comma_separator': return group(cents, '.', ',', 2);
      case 'amount_no_decimals_with_comma_separator': return group(cents, '.', ',', 0);
      case 'amount_with_apostrophe_separator': return group(cents, "'", '.', 2);
      default: return group(cents, ',', '.', 2);
    }
  });
}

function initMtPurchase(root) {
  var purchase = root.querySelector('[data-mt-purchase]');
  var dataEl = root.querySelector('[data-mt-plans-data]');
  if (!purchase || !dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var variantInput = root.querySelector('[data-mt-variant-id]');
  var radios = purchase.querySelectorAll('input[name="mt_purchase"]');
  var options = purchase.querySelectorAll('[data-mt-opt]');
  var plansBox = purchase.querySelector('[data-mt-plans]');
  var select = purchase.querySelector('[data-mt-plan-select]');
  var sellingPlanInput = purchase.querySelector('[data-mt-selling-plan]');
  var onetimePrice = purchase.querySelector('[data-mt-onetime-price]');
  var subPrice = purchase.querySelector('[data-mt-sub-price]');
  var subTitle = purchase.querySelector('[data-mt-sub-title]');

  function currentVariant() {
    return data[variantInput.value];
  }

  function isSubscribe() {
    var checked = purchase.querySelector('input[name="mt_purchase"]:checked');
    return checked && checked.value === 'subscribe';
  }

  function allocationFor(variant, planId) {
    if (!variant) return null;
    for (var i = 0; i < variant.allocations.length; i++) {
      if (String(variant.allocations[i].plan) === String(planId)) return variant.allocations[i];
    }
    return null;
  }

  function percentOff(variant, allocation) {
    if (!variant || !allocation || !variant.price) return 0;
    return Math.round(((variant.price - allocation.price) / variant.price) * 100);
  }

  function refresh() {
    var variant = currentVariant();
    if (!variant) return;
    if (onetimePrice) onetimePrice.textContent = mtMoney(variant.price);

    var pcts = variant.allocations.map(function (a) { return percentOff(variant, a); }).filter(function (p) { return p > 0; });
    if (subTitle && pcts.length) {
      var max = Math.max.apply(null, pcts);
      var min = Math.min.apply(null, pcts);
      subTitle.textContent = max === min ? 'Subscribe & save ' + max + '%' : 'Subscribe & save up to ' + max + '%';
    }

    var allocation = allocationFor(variant, select.value);
    if (subPrice && allocation) subPrice.textContent = mtMoney(allocation.perDelivery);

    if (isSubscribe()) {
      sellingPlanInput.value = select.value;
      sellingPlanInput.removeAttribute('disabled');
    } else {
      sellingPlanInput.value = '';
      sellingPlanInput.setAttribute('disabled', 'disabled');
    }
    if (plansBox) plansBox.hidden = !isSubscribe();
    options.forEach(function (opt) {
      var input = opt.querySelector('input');
      opt.classList.toggle('is-active', input && input.checked);
    });
  }

  radios.forEach(function (r) { r.addEventListener('change', refresh); });
  select.addEventListener('change', refresh);
  root.addEventListener('mt:variant-change', refresh);
  refresh();
}

function initMtLimit(root) {
  var form = root.querySelector('[data-mt-product-form]');
  var msg = root.querySelector('[data-mt-limit-msg]');
  var max = parseInt(root.getAttribute('data-mt-max'), 10);
  if (!form || !msg || !max) return;
  var bypass = false;
  form.addEventListener('submit', function (e) {
    if (bypass) return;
    e.preventDefault();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var handle = location.pathname.split('/products/')[1];
        handle = handle ? handle.split('/')[0].split('?')[0] : '';
        var inCart = 0;
        (cart.items || []).forEach(function (it) { if (it.handle === handle) inCart += it.quantity; });
        if (inCart >= max) { msg.hidden = false; return; }
        msg.hidden = true; bypass = true; form.submit();
      })
      .catch(function () { bypass = true; form.submit(); });
  });
}

function initMtProduct() {
  var root = document.querySelector('[data-mt-product]');
  if (!root) return;
  initMtLimit(root);

  // Gallery: click a thumbnail to swap the main image.
  var mainImg = root.querySelector('[data-mt-main-image]');
  var thumbs = root.querySelectorAll('[data-mt-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.dataset.full;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    });
  });

  // Subscribe & save selector (only rendered for products with a selling plan).
  initMtPurchase(root);

  // Variants: only present when the product has more than the default variant.
  var variantsScript = root.querySelector('[data-mt-variants]');
  if (!variantsScript) return;

  var variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (e) {
    return;
  }

  var optionGroups = root.querySelectorAll('[data-mt-option-index]');
  var variantIdInput = root.querySelector('[data-mt-variant-id]');
  var priceNow = root.querySelector('.mt-product-price-now');
  var priceWas = root.querySelector('.mt-product-price-was');
  var addButton = root.querySelector('[data-mt-add-button]');
  var addText = root.querySelector('[data-mt-add-text]');

  function selectedOptions() {
    var selected = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector('.mt-option-value.is-active');
      selected.push(active ? active.dataset.mtOptionValue : null);
    });
    return selected;
  }

  function findVariant() {
    var selected = selectedOptions();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function updateUI() {
    var variant = findVariant();
    if (!variant) return;
    variantIdInput.value = variant.id;
    if (priceNow) priceNow.textContent = mtMoney(variant.price);
    if (priceWas) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWas.textContent = mtMoney(variant.compare_at_price);
        priceWas.style.display = '';
      } else {
        priceWas.style.display = 'none';
      }
    }
    if (variant.available) {
      addButton.removeAttribute('disabled');
      if (addText) addText.textContent = addButton.dataset.mtAddLabel || addText.textContent;
    } else {
      addButton.setAttribute('disabled', 'disabled');
    }
    root.dispatchEvent(new CustomEvent('mt:variant-change', { detail: { id: variant.id } }));
  }

  optionGroups.forEach(function (group) {
    group.querySelectorAll('.mt-option-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.mt-option-value').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        updateUI();
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initMtProduct();
});
